export default {
  data() {
    return {
      members: [
        {
          name: "Alana Branston",
          title: "Co-Founder & CEO",
          image: "Alana_Branston.jpeg",
        },
        {
          name: "Ali Kriegsman",
          title: "Co-Founder & COO",
          image: "2.png",
        },
        {
          name: "Rachel Krug",
          title: "CRO",
          image: "Rachel_Krug.jpg",
        },
        {
          name: "Syd Alperowicz",
          title: "Head of Product",
          image: "3.png",
        },
        {
          name: "Sandeep Chayapathi",
          title: "Head of Engineering",
          image: "4.png",
        },
        {
          name: "Nick Tyson",
          title: "Head of Finance",
          image: "Nick_Tyson.jpeg",
        },
        {
          name: "David McClain",
          title: "Lead Backend Engineer",
          image: "David_Mcclain.jpeg",
        },
        {
          name: "Brooklyn Gallagher",
          title: "Director of Brand and Retailer Partnerships",
          image: "5.png",
        },
        {
          name: "Kiara Brown",
          title: "Director of Marketing and Merchandising",
          image: "6.png",
        },
        {
          name: "Aubree Andres",
          title: "Associate Product Manager",
          image: "Aubree_Andres.jpeg",
        },
        {
          name: "Paul Gladstone",
          title: "Staff Engineer",
          image: "9.png",
        },
        {
          name: "Darla Magnani",
          title: "Accountant",
          image: "Darla_Magnani.jpeg",
        },
        {
          name: "Tina Falzarano",
          title: "Part-time CFO",
          image: "13.png",
        },
        {
          name: "Cameron McCree",
          title: "Retailer Partnerships Associate",
          image: "Cameron_Mccree.jpeg",
        },
        {
          name: "Caytee Pavich",
          title: "Merchandising Associate",
          image: "caytee.jpeg",
        },
        {
          name: "Stefan Milović",
          title: "Software Engineer",
          image: "stefan.png",
        },
        {
          name: "Shayna Ventricelli",
          title: "Marketing Manager",
          image: "Shayna_Ventricelli.jpg",
        },
        {
          name: "Emily Cox",
          title: "Account Executive",
          image: "Emily_Cox.jpeg",
        },
        {
          name: "Han Duong",
          title: "Customer Experience Associate",
          image: "Han_Doung.jpeg",
        },
        {
          name: "Debora Suarez",
          title: "QA Analyst",
          image: "Debora_Suarez.jpg",
        },
        {
          name: "Dragoslav Dimitrijevic",
          title: "QA Engineer",
          image: "Dragoslav_Dimitrijevic.jpg",
        },
        // {
        //     name: 'Tatiana Ingram',
        //     title: 'Ops Intern',
        //     image: '' // activate once photo is sent
        // },
        {
          name: "Geza Nagy",
          title: "Software Engineer",
          image: "Geza_Nagy.jpg",
        },
        {
          name: "Keegan Connolly",
          title: "Sales Operations Manager",
          image: "Keegan_Connolly.jpg",
        },
        {
          name: "Alex Swensen",
          title: "Software Engineer",
          image: "Alex_Swensen.png",
        },
        {
          name: "Michelle Kim",
          title: "Senior UX Designer",
          image: "Michelle_Kim.jpg",
        },
        {
          name: "Christina Skramstad",
          title: "Operations Lead",
          image: "Christina_Skramstad.jpg",
        },
        {
          name: "Dior Acevedo",
          title: "Customer Experience Manager",
          image: "Dior_Acevedo.jpeg",
        },
        {
          name: "Imran Ansari",
          title: "Senior Software Engineer",
          image: "Imran_Ansari.jpeg",
        },
      ],
      advisors: [
        {
          name: "Lisa Bougie",
          title: "Former CMO at Stitch Fix",
          image: "Lisa_Bougie.png",
        },
        {
          name: "Bryan Wolff",
          title: "Former CFO at Bonobos and Thrive Market",
          image: "Bryan_Wolff.jpeg",
        },
        {
          name: "Dennis Goedegebuure",
          title: "Former Head of Global SEO at Airbnb and Head of Growth and Fanatics",
          image: "Dennis_Geodegebuure.jpeg",
        },
        {
          name: "Jon Dobrowolski",
          title: "Former VP of Product at Grailed and Invision",
          image: "Jon_Dobrowolski.jpeg",
        },
      ],
      press: [
        {
          image: "nyt.png",
          link: "https://www.nytimes.com/2017/11/15/style/bulletin-broads-feminist-flea-market.html",
          class: "span-3 span-12-md",
        },
        {
          image: "tc.png",
          link: "https://techcrunch.com/2017/05/24/bulletin-seed-funding/",
          class: "span-3 span-12-md",
        },
        {
          image: "wholesaleinabox.png",
          link: "https://www.wholesaleinabox.com/growingsteadyblog/bulletin-wholesale-reviews-and-maker-tips",
          class: "span-3 span-12-md",
        },
        {
          image: "entrepreneur.png",
          link: "https://www.entrepreneur.com/article/377263",
          class: "span-3 span-12-md",
        },
        {
          image: "adweek.png",
          link: "https://www.adweek.com/performance-marketing/the-growth-of-online-marketplaces-in-2021-and-beyond/",
          class: "span-4 span-12-md",
        },
        {
          image: "glossy.png",
          link: "https://www.glossy.co/fashion/online-marketplaces-are-rushing-to-the-aid-of-their-small-business-partners/",
          class: "span-4 span-12-md",
        },
        {
          image: "bof.png",
          link: "https://www.businessoffashion.com/articles/retail/local-retail-pandemic-brick-and-mortar",
          class: "span-4 span-12-md",
        },
      ],
    };
  },
};
